/**
 * Shared Chart.js configuration for a consistent, modern look across all charts.
 * Import and spread into your chart options.
 */

// Styled tooltip — dark rounded box, consistent across all chart types
export const tooltipConfig = {
  enabled: true,
  backgroundColor: '#475260',
  titleColor: '#fff',
  bodyColor: '#fff',
  titleFont: { size: 12, weight: '600' },
  bodyFont: { size: 12 },
  padding: { top: 8, bottom: 8, left: 12, right: 12 },
  cornerRadius: 8,
  displayColors: true,
  boxWidth: 8,
  boxHeight: 8,
  boxPadding: 4,
  caretSize: 6,
};

// Clean grid — light lines, no border
export const gridConfig = {
  x: {
    grid: { display: false },
    ticks: {
      color: '#8ca4aa',
      font: { size: 11, weight: '500' },
      padding: 8,
    },
    border: { display: false },
  },
  y: {
    grid: { color: '#f0f3f3', drawBorder: false },
    ticks: {
      color: '#8ca4aa',
      font: { size: 11, weight: '500' },
      padding: 8,
      precision: 0,
    },
    border: { display: false },
    min: 0,
  },
};

// Legend — clickable chips. Bigger / bolder text + a rounded square marker
// reads more like a tappable tag than a passive label; the onHover callback
// flips the canvas cursor to a pointer so merchants know they can click to
// hide/show a series.
export const legendConfig = {
  display: true,
  position: 'top',
  align: 'end',
  onHover: event => {
    const target = event?.native?.target;
    // eslint-disable-next-line no-param-reassign
    if (target) target.style.cursor = 'pointer';
  },
  onLeave: event => {
    const target = event?.native?.target;
    // eslint-disable-next-line no-param-reassign
    if (target) target.style.cursor = 'default';
  },
  labels: {
    usePointStyle: true,
    pointStyle: 'rectRounded',
    boxWidth: 10,
    boxHeight: 10,
    padding: 18,
    color: '#1f2937',
    font: { size: 12, weight: '600' },
  },
};

// Animation — snappy
export const animationConfig = {
  duration: 600,
  easing: 'easeOutQuart',
};
